import { LiquidityPool } from "../../PoolContext";
import PrimaryMarketCard from "../cards/PrimaryMarketCard";
import SecondaryMarketCard from "../cards/SecondaryMarketCard";
import StaticCard from "../cards/StaticCard";
import CardEarn from "./CardEarn";
import LoadingContainer from "./LoadingContainer";

export default function CardsCollectionPrimaryMarket(props: { tokensList: any[], hide: any[], categoryName?: string}): JSX.Element {

    const list = props.tokensList ? props.tokensList : []
    let cat = props.categoryName ? props.categoryName : "All"

    return <>

        <div className="flex flex-wrap place-content-center items-center p-2 gap-2">
            {list.length > 0 ?
                list.map((m: any, i: number) =>
                    <LoadingContainer isReady={true} small className="md:w-96 w-80">
                        <PrimaryMarketCard assetInfo={m} key={i} id={i} className={props.hide.includes(i) ? " hidden" : ""} />
                    </LoadingContainer>)
                : <></>}
            {cat === "All" || cat === "SPORTEX" ?
                <StaticCard title="Coming soon" category="SPORTEX" color="succ2_lighter" /> : <></>}
            {cat === "All" || cat === "IF" ?
                <StaticCard title="Coming soon" category="INVESTMENT FUNDS" color="succ2_lighter" /> : <></>}
            {cat === "All" || cat === "COLLECTABLES" ?
                <StaticCard title="Coming soon" category="COLLECTABLES" color="succ2_lighter" /> : <></>}
            {cat === "All" || cat === "ART" ?
                <StaticCard title="Coming soon" category="ART" color="succ2_lighter" /> : <></>}
        </div> :

    </>
}

export function CardsCollectionEarnLiquidityPool(props: { lpList: LiquidityPool[], hide: any[], categoryName?: string }): JSX.Element {

    let cat = props.categoryName ? props.categoryName : "All"

    return <>
        <div className={"flex flex-wrap place-content-center p-2 gap-2"}>
            {
                props.lpList.map((lp: LiquidityPool, i: number) => <CardEarn
                    info={lp} key={i} className={props.hide.includes(i) ? " hidden " : ""} />)
            }
            {
                cat === "All" || cat === "SPORTEX" ?
                    <StaticCard title="Coming soon" category="SPORTEX" color="succ7_lighter" /> : <></>
            }
            {
                cat === "All" || cat === "IF" ?
                    <StaticCard title="Coming soon" category="INVESTMENT FUNDS" color="succ7_lighter" /> : <></>
            }
            {
                cat === "All" || cat === "COLLECTABLES" ?
                    <StaticCard title="Coming soon" category="CLLCT" color="succ7_lighter" /> : <></>
            }
            {
                cat === "All" || cat === "ART" ?
                    <StaticCard title="Coming soon" category="ART" color="succ7_lighter" /> : <></>
            }
        </div>
    </>
}

export function CardsCollectionInvestSecondaryMarket(props: { uniqueTokens: any[], hide: any[], categoryName?: string, isLogged: boolean }): JSX.Element {

    const list = props.uniqueTokens ? props.uniqueTokens : []
    let cat = props.categoryName ? props.categoryName : "All"

    return <>
        {list.length > 0 ?

            <div className="flex flex-wrap place-content-center p-2 gap-2">
                {list.map((m: any, i: number) =>
                    <SecondaryMarketCard token={m} key={i} hide={props.hide.includes(i)} />)}
                {props.isLogged && (cat === "All" || cat === "IF") ? <StaticCard title="Coming soon"
                    category="INVESTMENT FUNDS" color="succ3_lighter" /> : <></>}
            </div> : <div className="p-3"><div className=" flex place-content-center p-2 text-tertiary font-roboto font-thin text-xl h-96">
                No tokens in secondary market available
            </div></div>}
    </>
}